import { render, staticRenderFns } from "./Collections.vue?vue&type=template&id=46791461&"
import script from "./Collections.vue?vue&type=script&lang=ts&"
export * from "./Collections.vue?vue&type=script&lang=ts&"
import style0 from "./Collections.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports